import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import Spinner from "../../components/spinner/spinner";
import { Form, Formik } from "formik";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import styles from "./duplicateOrdersScreen.module.scss";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import * as constants from "../../constants/constants";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatDate } from "../../constants/constants";
import { ConfirmDialog } from "primereact/confirmdialog";
import { MultiSelect } from "primereact/multiselect";
import React from "react";
import * as Yup from "yup";
import {
  duplicateOrdersLineItemsColumns,
  duplicateOrdersColumns
} from "../../constants/table-columns/tableColumns";
import {
  getDuplicateOrdersByRegionCode as getDuplicateOrders,
  postTfnwOrdersToD365
} from "../../services/BajaOrderService";
import { appInsights } from "../../AppInsights";

const DuplicateOrdersScreen = ({ regionName, btnCol, updateColSpan }) => {
  const toast = useRef(null);
  const toastTopRight = useRef(null);
  const formRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageRows, setCurrentPageRows] = useState(10);
  const [disableFields, setDisableFields] = useState(false);
  const formRefForDuplicateOrdersUpdate = useRef(null);
  const [showSpinner, setShowSpinner] = useState(false);
  const [duplicateOrders, setDuplicateOrders] = useState([]);
  const [selectedDuplicateOrders, setSelectedDuplicateOrders] = useState([]);
  const [allExpanded, setAllExpanded] = useState(false);
  const [expandedRows, setExpandedRows] = useState(null);
  const [
    showDuplicateOrderSendToD365ConfirmDialog,
    setShowDuplicateOrderSendToD365ConfirmDialog
  ] = useState(false);
  const [sendToD365DuplicateOrders, setSendToD365DuplicateOrders] = useState([]);
  appInsights.trackPageView({ name: `${regionName} Duplicate Orders screen visited` });
  const lineOfBusinessStatusFilter = [
    { label: "Produce", value: "Produce" },
    { label: "Deli", value: "Deli" }
  ];
  const customerFilter = [
    { label: "Qfc", value: "QFC" },
    { label: "Fred Meyer ", value: "Fred Meyer" }
  ];
  const customerGroupFilter = [
    { label: "ALBSFWYPHX", value: "ALBSFWYPHX" },
    { label: "FRYSDELI", value: "FRYSDELI" },
    { label: "FRYSPRO", value: "FRYSPRO" },
    { label: "KINGSOOP", value: "KINGSOOP" },
    { label: "RALPH", value: "RALPH" },
    { label: "SBUXLV", value: "SBUXLV" },
    { label: "SBUXLVB", value: "SBUXLVB" },
    { label: "SBUXPHX", value: "SBUXPHX" },
    { label: "SMTHDELI", value: "SMTHDELI" },
    { label: "SMTHPRO", value: "SMTHPRO" }
  ];
  const customerRequisition = [
    { label: "Deli", value: "b" },
    { label: "Home Chef", value: "h" }
  ];
   const customerWave = [
   { label: "KRHou1", value: "KRHou1" },
   { label: "KRDal1", value: "KRDal1" },
   { label: "KFK-HUTCH", value: "KFK-HUTCH" }
  ];
  const salesOriginFilter = [
   { label: "EDI", value: "EDI" },
   { label: "MOJO", value: "MOJO" },
  ];
  const uomBajaOrdersUpdateDropdownOptions = [
    { label: "CASE", value: "CASE" },
    { label: "EACH", value: "EACH" }
  ];
  const initialValues = {
    requestedShippingDate: new Date(),
    ...(regionName.toLocaleLowerCase() == "tfnw" && {
      linesOfBusiness: "",
      customer: ""
    }),
    ...(regionName.toLocaleLowerCase() == "tfsw" && {
      customerGroup: ""
    }),
    ...(regionName.toLocaleLowerCase() == "tftx" && {
      customer: "",
      customerWave:""
    }),
    ...(regionName.toLocaleLowerCase() == "tftn" && {
      invoiceNumbers: "",
      salesOrigin: "",
    }),
  };
  const validationSchema = Yup.object().shape({
    requestedShippingDate: Yup.date().required(
      "Requested Ship Date is required"
    ),
    ...(regionName.toLocaleLowerCase() == "tfsw" && {
      customerGroup: Yup.array()
        .min(1, "At least one Customer Group is required")
        .required("Customer Group is required")
    }),
    ...(regionName.toLocaleLowerCase() == "tfnw" && {
      linesOfBusiness: Yup.array()
        .min(1, "At least one Line of Business is required")
        .required("Line of Business is required"),
      customer: Yup.array()
        .min(1, "At least one Customer is required")
        .required("Customer is required")
    }),
    ...(regionName.toLocaleLowerCase() == "tftx" && {
      customer: Yup.array().nullable(),
      customerWave: Yup.array().nullable(),
    }),
    ...(regionName.toLocaleLowerCase() == "tftn" && {
      invoiceNumbers: Yup.array()
        .min(1, "At least one Invoice Number is required")
        .required("Invoice Number is required"),
      salesOrigin: Yup.array()
        .min(1, "At least one Sales Origin is required")
        .required("Sales Origin is required"),
    }),
  });
  const initialValuesForDuplicateOrdersUpdate = {
    shipDate: "",
    ...(regionName.toLocaleLowerCase() === "tbcp" &&
    {
      quantity: 2,
      uom: "EACH"
    }),
    ...(regionName.toLocaleLowerCase() === "tffl" &&
    {
      customerId: ""
    })
  };
  function formatShipDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("-");
  }
  function formatDateToYYYYMMDD(date) {
    let selectedDate = new Date(date);
    let year = selectedDate.getFullYear(); // Use getFullYear() instead of getYear()
    let month = (selectedDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-indexed, so add 1 and pad
    let day = selectedDate.getDate().toString().padStart(2, "0"); // Pad the day if it’s a single digit
    return `${year}${month}${day}`;
  }
  const fetchDuplicateOrders = async (values) => {
    try {
      setShowSpinner(true);
      values = {
        shipDate: values?.requestedShippingDate
          ? formatDate(values?.requestedShippingDate)
          : null,
        ...(regionName.toLocaleLowerCase() == "tfnw" && {
          customers: values?.customer ? values?.customer : null,
          linesOfBusiness: values?.linesOfBusiness
            ? values?.linesOfBusiness
            : null
        }),
        ...(regionName?.toLocaleLowerCase() == "tfsw" && {
          customerGroups: values?.customerGroup ? values?.customerGroup : null
        }),
        ...(regionName?.toLocaleLowerCase() == "tftx" && {
          customers: values?.customer ? values?.customer : null,
          customerWave: values?.customerWave ? values?.customerWave : null,
        }),
        ...(regionName?.toLocaleLowerCase() == "tftn" && {
          invoiceNumbers: values?.invoiceNumbers ? values?.invoiceNumbers : null,
          salesOrigin: values?.salesOrigin ? values?.salesOrigin : null
        })
      };
      let result = await getDuplicateOrders(values, `${regionName}`);
      //INFO : initial changes
      const updatedResult = result.map((order) => ({
        ...order,
        salesOrderLineItems: order?.salesOrderLineItems?.map((item) => ({
          ...item,
          ...(regionName.toLowerCase() === "tbcp" && {
            quantity: Number(formRefForDuplicateOrdersUpdate.current.values.quantity),
            unit: formRefForDuplicateOrdersUpdate.current.values.uom ?? 0
          }),
        })),
      }));
      setDuplicateOrders(updatedResult);
      setSelectedDuplicateOrders([]);
      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);
      setDuplicateOrders([]);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.message,
        life: 4000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo: `Exception while Fetching ${regionName} Duplicate orders`
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
  };
  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-1 pl-5 ml-5">
        <DataTable
          value={data.salesOrderLineItems}
          scrollable
          paginator={constants.paginator}
          rows={constants.defaultRows}
          rowsPerPageOptions={constants.rowsPerPageOptions}
          paginatorTemplate={constants.paginatorTemplate}
          currentPageReportTemplate={constants.currentPageReportTemplate}
          emptyMessage={constants.emptyMessage}
        >
          {duplicateOrdersLineItemsColumns.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable={col.sort}
              style={{ minWidth: col.minWidth }}
              body={col.value}
              headerStyle={{ minWidth: col.minWidth }}
              paginatorTemplate={constants?.paginatorTemplate}
              paginator={constants?.paginator}
              rows={constants?.defaultRows}
              rowsPerPageOptions={constants?.rowsPerPageOptions}
              currentPageReportTemplate={constants?.currentPageReportTemplate}
            />
          ))}
        </DataTable>
      </div>
    );
  };
  const toggleRows = () => {
    if (allExpanded) {
      setExpandedRows(null);
      setAllExpanded(false);
    } else {
      let newExpandedRows = {};
      duplicateOrders.forEach(
        (p) => (newExpandedRows[`${p?.salesOrderNumber}`] = true)
      );
      setExpandedRows(newExpandedRows);
      setAllExpanded(true);
    }
  };
  const actionFormat = (rowData) => {
    return (
      <Button
        icon="pi pi-send"
        label="Send to D365"
        type="button"
        size="small"
        className={styles.sendToD365Btn}
        style={{ backgroundColor: "#22c55e", color: "white" }}
        onClick={() => onSendToD365Handler(rowData)}
      />
    );
  };
  const onUpdateHandler = () => {
    try {
      const hasValidShippingDate =
        formRefForDuplicateOrdersUpdate.current.values.shipDate &&
        formRefForDuplicateOrdersUpdate.current.values.shipDate.toString().trim() !==
        "";
      const hasValidCustomerId = formRefForDuplicateOrdersUpdate.current.values.customerId != null && formRefForDuplicateOrdersUpdate.current.values.customerId.toString().trim() !== "";
      if (duplicateOrders?.length === 0) {
        setShowSpinner(false);
        return;
      }
      if (!hasValidShippingDate) {
        toast.current?.show({
          severity: "warn",
          summary: "Warning",
          detail: "Please select valid ship Date",
          life: 3000
        });
        setShowSpinner(false);
        return;
      }
      let updatedDuplicateOrders = [];
      duplicateOrders.forEach((order) => {
        updatedDuplicateOrders.push({
          ...order,
          ...(hasValidShippingDate && {
            ...(regionName.toLocaleLowerCase() == "tfsw" && {
              customerPo: `${formatDateToYYYYMMDD(
                formRefForDuplicateOrdersUpdate.current.values.shipDate
              )}${order?.customerId}`,
            }),
            ...(regionName.toLocaleLowerCase() == "tftx" && {
              customerPo: `${formatDateToYYYYMMDD(
                formRefForDuplicateOrdersUpdate.current.values.shipDate
              )}${order?.customerId}`,
            }),
            ...(regionName.toLocaleLowerCase() == "tftn" && {
              customerPo: `${formatDateToYYYYMMDD(
                formRefForDuplicateOrdersUpdate.current.values.shipDate
              )}${order?.customerId}`,
            }),
            ...(regionName.toLocaleLowerCase() == "tfnw" && {
              customerPo: `${formatDateToYYYYMMDD(
                formRefForDuplicateOrdersUpdate.current.values.shipDate
              )}${order?.externalShipToId}`,
            }),
            ...(regionName.toLocaleLowerCase() == "tffl" && {
              ...(hasValidCustomerId && {
                customerId: formRefForDuplicateOrdersUpdate?.current?.values?.customerId,
              }),
            }),
            shipRequestDate: formatShipDate(
              formRefForDuplicateOrdersUpdate?.current?.values?.shipDate
            ),
            receiptDate: formatShipDate(
              formRefForDuplicateOrdersUpdate.current.values.shipDate
            )
          }),
          salesOrderLineItems: order?.salesOrderLineItems.map((item) => ({
            ...item,
            ...(hasValidShippingDate && {
              shipRequestDate: formatShipDate(
                formRefForDuplicateOrdersUpdate.current.values.shipDate
              ),
              ...(regionName.toLocaleLowerCase() == "tfsw" && {
                customerPo: `${formatDateToYYYYMMDD(
                  formRefForDuplicateOrdersUpdate.current.values.shipDate
                )}${order?.customerId}`,
              }),
              ...(regionName.toLocaleLowerCase() == "tftx" && {
                customerPo: `${formatDateToYYYYMMDD(
                  formRefForDuplicateOrdersUpdate.current.values.shipDate
                )}${order?.customerId}`,
              }),
              ...(regionName.toLocaleLowerCase() == "tftn" && {
                customerPo: `${formatDateToYYYYMMDD(
                  formRefForDuplicateOrdersUpdate.current.values.shipDate
                )}${order?.customerId}`,
              }),
              ...(regionName.toLocaleLowerCase() == "tfnw" && {
                customerPo: `${formatDateToYYYYMMDD(
                  formRefForDuplicateOrdersUpdate.current.values.shipDate
                )}${order?.externalShipToId}`,
              }),
              ...(regionName.toLocaleLowerCase() == "tffl" && {
                ...(hasValidCustomerId && {
                  customerId: formRefForDuplicateOrdersUpdate?.current?.values?.customerId,
                }),
              }),
              ...(regionName.toLocaleLowerCase() == "tbcp" && {
                quantity: Number(formRefForDuplicateOrdersUpdate.current.values.quantity),
                unit: formRefForDuplicateOrdersUpdate.current.values.uom ?? 0
              }),
            })
          }))
        });
      });
      setDuplicateOrders(updatedDuplicateOrders);
      setSelectedDuplicateOrders([]);
      setShowSpinner(false);
      toastTopRight.current?.show({
        severity: "success",
        summary: "Success",
        detail: `Orders updated successfully.`,
        life: 2000
      });
    } catch (error) {
      setShowSpinner(false);
    }
  };
  const onSendToD365Handler = (rowData) => {
    if (rowData) {
      setSendToD365DuplicateOrders([rowData]);
    } else {
      if (selectedDuplicateOrders.length === 0) {
        toast.current?.show({
          severity: "warn",
          summary: "Warning",
          detail: `Please select at least one Order to Send to D365.`,
          life: 3000
        });
        return;
      }
      setSendToD365DuplicateOrders(selectedDuplicateOrders);
    }
    setShowDuplicateOrderSendToD365ConfirmDialog(true);
  };
  const duplicateOrderSendToD365Accept = async () => {
    try {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      let firstRowDate = new Date(duplicateOrders[0]?.shipRequestDate);
      firstRowDate.setHours(0, 0, 0, 0);
      if (firstRowDate < today) {
        toast.current.show({
          severity: "warn",
          summary: "Warning",
          detail: "Ship Request Date must be atleast today in order to Send.",
          life: 3000
        });
        return;
      }
      setShowSpinner(true);
      const response = await postTfnwOrdersToD365(sendToD365DuplicateOrders, regionName);
      if (response?.statusCode === 200) {
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail:
            sendToD365DuplicateOrders.length +
            " " +
            "Orders have been successfully created.",
          life: 3000
        });
      } else if (response?.statusCode) {
        toast.current?.show({
          severity: "error",
          summary: "Send to D365 Failed",
          detail: response.result,
          life: 3000
        });
      }
      setDuplicateOrders([]);
      setSelectedDuplicateOrders([]);
      setSendToD365DuplicateOrders([]);
      setShowSpinner(false);
    } catch (error) {
      setShowSpinner(false);
      toast.current?.show({
        severity: "error",
        summary: "Send to D365 Failed",
        detail: error.message,
        life: 3000
      });
      appInsights.trackException({
        exception: error,
        properties: {
          additionalInfo: `Exception while Saving ${regionName} Duplicate orders`
        },
        measurements: {
          severityLevel: 2
        }
      });
    }
    setShowSpinner(false);
  };
  const duplicateOrderSendToD365Reject = () => {
    setShowDuplicateOrderSendToD365ConfirmDialog(false);
    setSendToD365DuplicateOrders([]);
  };
  const dataTableFooter = (
    <div className="p-2">
      <Button
        icon="pi pi-send"
        label="Send to D365"
        size="medium"
        type="button"
        className={styles.updateAndSendBtn}
        onClick={() => {
          onSendToD365Handler(null);
        }}
      />
    </div>
  );
  return (
    <>
      {showSpinner && <Spinner />}
      <ConfirmDialog
        visible={showDuplicateOrderSendToD365ConfirmDialog}
        onHide={duplicateOrderSendToD365Reject}
        message={
          sendToD365DuplicateOrders.length + " " +
          " Orders will be sent to D365. Do you want to proceed?"
        }
        header="Confirmation"
        icon="pi pi-exclamation-triangle"
        accept={duplicateOrderSendToD365Accept}
        reject={duplicateOrderSendToD365Reject}
      />
      <div className="grid align-items-end">
        <div className="col-12 xl:col-6 md:col-12">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, resetForm) => {
              setShowSpinner(true);
              setExpandedRows(null);
              setAllExpanded(false);
              setCurrentPage(0);
              setCurrentPageRows(10);
              fetchDuplicateOrders(values);
            }}
            innerRef={formRef}
          >
            {({
              values,
              handleChange,
              handleSubmit,
              errors,
              touched,
              setFieldValue
            }) => (
              <Form onSubmit={handleSubmit} ref={formRef}>
                <div className="grid">
                  <div className="col-12 md:col-3 xl:col-4">
                    <div className={styles.formLabelContainer}>
                      <label htmlFor="requestedShippingDate">
                        <span className={styles.formLabel}>
                          Requested Ship Date
                        </span>
                      </label>

                    </div>
                    <Calendar
                      inputId="requestedShippingDate"
                      value={values?.requestedShippingDate}
                      onChange={(e) => setFieldValue("requestedShippingDate", e.value)}
                      disabled={disableFields}
                      placeholder="Date"
                      style={{ height: "2.469rem" }}
                    />
                    {touched.requestedShippingDate &&
                      errors.requestedShippingDate && (
                        <small className="p-error">
                          {errors.requestedShippingDate}
                        </small>
                      )}
                  </div>
                  {regionName.toLocaleLowerCase() == "tfsw"
                    &&
                    (<>
                      <div className="col-12 md:col-4">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="customerGroup">
                            <span className={styles.formLabel}>Customer Group</span>
                          </label>
                        </div>
                        <MultiSelect

                          id="customerGroup"
                          placeholder="--Select--"
                          value={values?.customerGroup}
                          options={customerGroupFilter}
                          onChange={(e) => setFieldValue("customerGroup", e.value)}
                          className={`${styles.dropdown} ${styles.formControl}`}
                          maxSelectedLabels={1}
                        />
                        {touched.customerGroup && errors.customerGroup && (
                          <small className="p-error">{errors.customerGroup}</small>
                        )}
                      </div></>)}
                  {regionName.toLocaleLowerCase() == "tftx"
                    &&
                    (<>
                      <div className="col-12 md:col-3 xl:col-4">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="customer">
                            <span className={styles.formLabel} style={{ whiteSpace: 'nowrap' }}>Customer{" "}Requisition</span>

                          </label>
                        </div>
                        <MultiSelect
                          id="customer"
                          placeholder="--Select--"
                          value={values?.customer}
                          options={customerRequisition}
                          onChange={(e) => setFieldValue("customer", e?.value)}
                          className={`${styles.dropdown} ${styles.formControl}`}
                          maxSelectedLabels={1}
                        />
                        {touched?.customer && errors?.customer && (
                          <small className="p-error">{errors?.customer}</small>
                        )}
                      </div>
                         <div className="col-12 md:col-3">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="customerWave">
                            <span className={styles.formLabel} style={{ whiteSpace: 'nowrap' }}>Customer{" "}Wave</span>
                          </label>
                        </div>
                        <MultiSelect
                          id="customerWave"
                          placeholder="--Select--"
                          value={values?.customerWave}
                          options={customerWave}
                          onChange={(e) => setFieldValue("customerWave", e?.value)}
                          className={`${styles.dropdown} ${styles.formControl}`}
                          maxSelectedLabels={1}
                        />
                        {touched?.customerWave && errors?.customerWave && (
                          <small className="p-error">{errors?.customerWave}</small>
                        )}
                      </div>
                      </>)}
                  {regionName.toLocaleLowerCase() == "tftn"
                    &&
                    (<>
                      <div className="col-12 md:col-3 xl:col-4 ">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="invoiceNumbers">
                            <span className={styles.formLabel}>Invoice Numbers</span>
                          </label>
                        </div>
                        <MultiSelect

                          id="invoiceNumbers"
                          placeholder="--Select--"
                          value={values?.invoiceNumbers}
                          options={["104200", "109800", "109600", "190000", "210000", "300000", "370000", "375000"]}
                          onChange={(e) => setFieldValue("invoiceNumbers", e.value)}
                          className={`${styles.dropdown} ${styles.formControl}`}
                          maxSelectedLabels={1}
                        />
                        {touched.invoiceNumbers && errors.invoiceNumbers && (
                          <small className="p-error">{errors.invoiceNumbers}</small>
                        )}
                      </div>
                        <div className="col-12 md:col-3 ">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="salesOrigin">
                            <span className={styles.formLabel}>Sales Origin</span>
                          </label>
                        </div>
                        <MultiSelect
                          id="salesOrigin"
                          placeholder="--Select--"
                          value={values?.salesOrigin}
                          options={salesOriginFilter}
                          onChange={(e) => setFieldValue("salesOrigin", e.value)}
                          className={`${styles.dropdown} ${styles.formControl}`}
                          maxSelectedLabels={1}
                        />
                        {touched.salesOrigin && errors.salesOrigin && (
                          <small className="p-error">{errors.salesOrigin}</small>
                        )}
                      </div>
                      </>)}

                  {regionName.toLocaleLowerCase() == "tfnw"
                    && (<>
                      <div className="col-12 md:col-3 xl:col-4">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="linesOfBusiness">
                            <span className={styles.formLabel}>
                              Line of Business
                            </span>
                          </label>

                        </div>
                        <MultiSelect
                          id="linesOfBusiness"
                          placeholder="--Select--"
                          value={values?.linesOfBusiness}
                          options={lineOfBusinessStatusFilter}
                          onChange={(e) =>
                            setFieldValue("linesOfBusiness", e?.value)
                          }
                          className={`${styles.dropdown} ${styles.formControl}`}
                          maxSelectedLabels={1}
                        />
                        {touched.linesOfBusiness && errors.linesOfBusiness && (
                          <small className="p-error">
                            {errors.linesOfBusiness}
                          </small>
                        )}
                      </div>
                      <div className="col-12 md:col-3">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="customer">
                            <span className={styles.formLabel}>Customer</span>
                          </label>
                        </div>
                        <MultiSelect
                          id="customer"
                          placeholder="--Select--"
                          value={values?.customer}
                          options={customerFilter}
                          onChange={(e) => setFieldValue("customer", e.value)}
                          className={`${styles.dropdown} ${styles.formControl}`}
                          maxSelectedLabels={1}
                        />
                        {touched.customer && errors.customer && (
                          <small className="p-error">{errors.customer}</small>
                        )}
                      </div></>)
                  }
                  <div className="col-12 md:col-3 xl:col-1 ">
                    <div className={styles.formLabelContainer} style={{ marginTop: "1.90rem" }}>
                      <Button
                        label="Search"
                        type="submit"
                        size="medium"
                        className={styles.primaryBtn}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="col-12 xl:col-6 md:col-8  xl:flex xl:justify-content-end">
          <Formik
            initialValues={initialValuesForDuplicateOrdersUpdate}
            onSubmit={(values) => {
              setCurrentPage(0);
              setCurrentPageRows(10);
              setShowSpinner(true);
              onUpdateHandler(values);
            }}
            innerRef={formRefForDuplicateOrdersUpdate}
          >
            {({ values, handleChange, handleSubmit, setFieldValue }) => (
              <Form onSubmit={handleSubmit} ref={formRefForDuplicateOrdersUpdate}>
                <div className="grid">
                  <div className={`col-12 ${updateColSpan}`} >
                    <div className={styles.formLabelContainer}>
                      <label htmlFor="shipDate">

                        <span className={styles.formLabel}>Ship Date</span>
                      </label>
                    </div>
                    <Calendar
                      id="shipDate"
                      value={values?.shipDate}
                      onChange={handleChange}
                      disabled={disableFields}
                      placeholder="Date"
                      minDate={new Date()}
                    />
                  </div>
                  {regionName.toLocaleLowerCase() == "tbcp"
                    && (<>
                      <div className="col-12 md:col-2">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="quantity">
                            <span className={styles.formLabel}>Quantity</span>
                          </label>
                        </div>
                        <InputNumber
                          id="quantity"
                          placeholder="Quantity"
                          onValueChange={(e) => setFieldValue("quantity", e.value)}
                          mode="decimal"
                          minFractionDigits={0}
                          maxFractionDigits={0}
                          useGrouping={false}
                          value={values?.quantity}
                          inputStyle={{ width: '100%' }}
                        />
                      </div>
                      <div className="col-12 md:col-3 ">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="uom">
                            <span className={styles.formLabel}>UOM</span>
                          </label>
                        </div>
                        <Dropdown
                          id="uom"
                          placeholder="Select a UOM"
                          value={values?.uom}
                          options={uomBajaOrdersUpdateDropdownOptions}
                          onChange={(e) => {
                            setFieldValue("uom", e.value);
                          }}
                          className={`${styles.dropdown} ${styles.formControl}`}
                        />
                      </div>
                    </>)
                  }
                  {regionName.toLocaleLowerCase() == "tffl"
                    && (<>
                      <div className="col-12 md:col-5">
                        <div className={styles.formLabelContainer}>
                          <label htmlFor="shipDate">
                            <span className={styles.formLabel}>Customer Id</span>

                          </label>
                        </div>
                        <InputText
                          id="customerId"
                          placeholder="Customer Id"
                          value={values?.customerId}
                          onChange={handleChange}
                          style={{ width: '100%' }}
                        />
                      </div>
                    </>)
                  }
                  <div className={`col-12 ${btnCol}`}>
                    <div className={styles.formLabelContainer} style={{ marginTop: "1.89rem" }}>
                      <Button
                        label="Update"
                        type="submit"
                        size="medium"
                        className={styles.updateAndSendBtn}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
      <div className="mt-4">
        <DataTable
          value={duplicateOrders}
          tableStyle={{ minWidth: "50rem" }}
          scrollable
          first={currentPage}
          rows={currentPageRows}
          onPage={(e) => { setCurrentPage(e.first); setCurrentPageRows(e?.rows) }}
          paginator={constants.paginator}
          rowsPerPageOptions={constants.rowsPerPageOptions}
          paginatorTemplate={constants.paginatorTemplate}
          currentPageReportTemplate={constants.currentPageReportTemplate}
          emptyMessage={constants.emptyMessage}
          dataKey="salesOrderNumber"
          scrollHeight="30vw"
          selectionMode="checkbox"
          selection={selectedDuplicateOrders}
          onSelectionChange={(e) => setSelectedDuplicateOrders(e.value)}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={rowExpansionTemplate}
          footer={dataTableFooter}
        >
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "4rem" }}
          ></Column>
          <Column
            header={
              <Button
                className={
                  allExpanded ? "pi pi-angle-down" : "pi pi-angle-right"
                }
                style={{
                  fontSize: "1.3rem",
                  color: "#6c757d",
                  backgroundColor: "#f8f9fa",
                  border: "none",
                  padding: "2px"
                }}
                onClick={toggleRows}
              ></Button>
            }
            style={{ width: "10px" }}
            expander={true}
          />
          {duplicateOrdersColumns.map((col, index) => (
            <Column
              key={index}
              field={col.field}
              header={col.header}
              sortable={col.sort}
              style={{ minWidth: col.minWidth }}
              headerStyle={{ minWidth: col.minWidth }}
              body={
                col.field.toLocaleLowerCase() === "action"
                  ? actionFormat
                  : col.value
              }
            />
          ))}
        </DataTable>
      </div>
      <Toast ref={toast} position="center" />
      <Toast ref={toastTopRight} position="top-right" />
    </>
  );
};
export default DuplicateOrdersScreen;